import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MonitorPlay, Clock, Smartphone, ChevronDown, ShoppingCart, Zap } from 'lucide-react';
// ── COMBO LINKS (Masterkit + POS) desde OfferStack_V2_POSVENTA ─────────────
const COMBO_LINKS = {
  basico: {
    label: 'Básico + POS',
    price: '$74.98',
    url: 'https://checkout.digitalsolvex.shop/cart/44112576086104:1'
  },
  pro: {
    label: 'PRO + POS',
    price: '$97.98',
    url: 'https://checkout.digitalsolvex.shop/cart/44112453238872:1'
  },
  vip: {
    label: 'VIP + POS',
    price: '$124.98',
    url: 'https://checkout.digitalsolvex.shop/cart/44112459366488:1'
  }
};
const benefits = [{
  icon: Clock,
  text: 'Factura en menos de 30 segundos en mostrador'
}, {
  icon: MonitorPlay,
  text: 'Tasa BCV automática — si no hay internet, la pones manual'
}, {
  icon: Smartphone,
  text: 'Tickets en PDF con tu logo, enviados directo a WhatsApp'
}];
export function POSOrderBump() {
  const [videoOpen, setVideoOpen] = useState(false);
  return <section className="px-4 md:px-6 lg:px-8 pb-6 max-w-5xl mx-auto" data-id="element-267">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="relative rounded-2xl border border-cyan-500/20 bg-[#0a0a0a] overflow-hidden" data-id="element-268">
        <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-cyan-400 to-blue-600" data-id="element-269" />

        <div className="p-6 md:p-8 pl-8 md:pl-10" data-id="element-270">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6" data-id="element-271">
            <div className="flex-1" data-id="element-272">
              <span className="inline-flex items-center gap-1.5 text-cyan-400 text-xs font-black uppercase tracking-widest bg-cyan-500/10 border border-cyan-500/20 px-3 py-1 rounded-full mb-4" data-id="element-273">
                <Zap className="w-3 h-3" data-id="element-274" /> Upgrade Opcional — PanelVentas POS
              </span>

              <h3 className="font-heading text-xl md:text-2xl font-black text-white mb-2 leading-tight" data-id="element-275">
                ¿Ya elegiste tu plan? Conviértelo en un{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400" data-id="element-276">
                  Punto de Venta completo
                </span>
              </h3>

              <p className="text-gray-400 text-sm mb-5 max-w-lg" data-id="element-277">
                El PanelVentas POS corre en el navegador, se conecta directo a
                tu Excel y registra cada venta sin que toques el archivo. Sin
                mensualidades, sin la nube.
              </p>

              <ul className="flex flex-col gap-2.5 mb-6" data-id="element-278">
                {benefits.map((b, i) => <li key={i} className="flex items-center gap-3" data-id="element-279">
                    <div className="w-7 h-7 rounded-lg bg-cyan-500/10 border border-cyan-500/15 flex items-center justify-center flex-shrink-0" data-id="element-280">
                      <b.icon className="w-3.5 h-3.5 text-cyan-400" data-id="element-281" />
                    </div>
                    <span className="text-gray-300 text-sm" data-id="element-282">{b.text}</span>
                  </li>)}
              </ul>

              <button onClick={() => setVideoOpen(!videoOpen)} className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 hover:text-cyan-400 transition-colors duration-200 mb-1" data-id="element-283">
                <motion.div animate={{
                rotate: videoOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-284">
                  <ChevronDown className="w-3.5 h-3.5" data-id="element-285" />
                </motion.div>
                {videoOpen ? 'Ocultar demo' : 'Ver demo del POS en acción →'}
              </button>

              <AnimatePresence data-id="element-286">
                {videoOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden mt-3" data-id="element-287">
                    <div className="aspect-video w-full max-w-lg rounded-xl overflow-hidden border border-white/10" data-id="element-288">
                      <iframe className="w-full h-full" src="https://www.youtube.com/embed/WMfjPs-ziu8?autoplay=0&rel=0" title="Demo PanelVentas POS" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-289" />
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <div className="md:w-64 flex flex-col gap-3 md:pt-1" data-id="element-290">
              <p className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-1 text-center md:text-left" data-id="element-291">
                Selecciona tu combo:
              </p>

              {Object.values(COMBO_LINKS).map(combo => <a key={combo.label} href={combo.url} className="flex items-center justify-between gap-3 w-full px-4 py-3 rounded-xl border border-cyan-500/20 bg-cyan-500/5 hover:bg-cyan-500/10 hover:border-cyan-500/40 transition-all duration-200 group" data-id="element-292">
                  <div className="flex items-center gap-2" data-id="element-293">
                    <ShoppingCart className="w-4 h-4 text-cyan-400 flex-shrink-0" data-id="element-294" />
                    <span className="text-white font-bold text-sm" data-id="element-295">
                      {combo.label}
                    </span>
                  </div>
                  <span className="text-cyan-400 font-black text-sm whitespace-nowrap" data-id="element-296">
                    {combo.price}
                  </span>
                </a>)}

              <p className="text-gray-600 text-[11px] text-center mt-1" data-id="element-297">
                Pago único · Sin mensualidades
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}